export default function VIPSection() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6">
      <h2 className="text-xl font-bold text-white bg-gradient-to-r from-red-600 to-red-500 px-4 py-2 rounded mb-4">
        VIP Tips
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead>
            <tr className="bg-red-500 text-white">
              <th className="border border-gray-300 px-3 py-2 text-center" colspan="5">
                Football Analysis SMS VIP
              </th>
            </tr>
            <tr className="bg-black text-white">
              <th className="border border-gray-300 px-3 py-2 text-center" colspan="5">
                SMS VIP: Send TDT to 4899101<br/>
                6 Baht per message, receive between 15:00-16:00
              </th>
            </tr>
            <tr className="bg-yellow-300">
              <th className="border border-gray-300 px-3 py-2 text-center">Date</th>
              <th className="border border-gray-300 px-3 py-2 text-center">Team 1</th>
              <th className="border border-gray-300 px-3 py-2 text-center">Team 2</th>
              <th className="border border-gray-300 px-3 py-2 text-center">Team 3</th>
              <th className="border border-gray-300 px-3 py-2 text-center">Team 4</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-green-300">
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">26/01/25 (VIP)</td>
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">SMS</td>
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">SMS</td>
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">SMS</td>
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">SMS</td>
            </tr>
            <tr className="bg-blue-900 text-white">
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">25/01/25 (VIP2)</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Roma ✓</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Schalke</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Racing Genk</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Panathinaikos</td>
            </tr>
            <tr className="bg-blue-400">
              <td className="border border-gray-300 px-3 py-2 text-center font-semibold">25/01/25 (VIP1)</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Barcelona ✓</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Brentford</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Atletico Madrid ✓</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Portsmouth ✓</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}